import React from "react";
import {
    Megaphone,
    Users,
    Lightbulb,
    Handshake,
    LifeBuoy,
    BadgeEuro,
} from "lucide-react";

const advantages = [
    {
        icon: Megaphone,
        title: "Representación del sector",
        desc: "Una voz común ante administraciones, medios y agentes clave del turismo.",
    },
    {
        icon: Users,
        title: "Visibilidad para tu alojamiento",
        desc: "Presencia en el directorio, campañas y canales de comunicación de ASATTA.",
    },
    {
        icon: Lightbulb,
        title: "Acceso a proyectos",
        desc: "Participa en iniciativas de sostenibilidad, digitalización y promoción de destino.",
    },
    {
        icon: Handshake,
        title: "Red de colaboración local",
        desc: "Conecta con otros alojamientos y actores del sector en Tarifa.",
    },
    {
        icon: LifeBuoy,
        title: "Información y apoyo continuo",
        desc: "Actualizaciones sobre normativa, ayudas y buenas prácticas del sector.",
    },
    {
        icon: BadgeEuro,
        title: "Cuota clara y sin sorpresas",
        desc: "15 €/mes por alojamiento asociado. Únete sin ataduras, pero con vocación. Pedimos a cada asociado un compromiso mínimo de un año para construir juntos una asociación fuerte.",
    },
];

export default function Advantages() {
    return (
        <section
            id="ventajas"
            data-testid="advantages-section"
            className="bg-[#F8F9FA] border-y border-[#E2E4E9]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="max-w-2xl mb-14">
                    <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                        Ventajas de unirse
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                        Todo lo que ganas siendo socio de ASATTA.
                    </h2>
                    <p className="mt-4 text-[#4A5568] text-lg">
                        Diseñado para hoteles, campings, hostales y apartamentos que
                        quieren impulsar su alojamiento y contribuir a un turismo mejor
                        en Tarifa.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E4E9] border border-[#E2E4E9]">
                    {advantages.map((a, i) => (
                        <div
                            key={a.title}
                            data-testid={`advantage-card-${i}`}
                            className="group bg-white p-8 hover:bg-[#082050] transition-colors"
                        >
                            <a.icon
                                size={28}
                                className="text-[#082050] group-hover:text-white transition-colors"
                                strokeWidth={1.5}
                            />
                            <h3 className="mt-6 text-lg font-semibold text-[#082050] group-hover:text-white transition-colors tracking-tight">
                                {a.title}
                            </h3>
                            <p className="mt-3 text-sm text-[#4A5568] group-hover:text-white/80 transition-colors leading-relaxed">
                                {a.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
